var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReact(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 94,
    viewBox: "0 0 104 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bii_231_160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.5 29.5L52 15.5L63.5 8L69.5 4H73.5L77 8L80.5 15.5L78.5 32L62.5 29.5Z",
    fill: "white",
    fillOpacity: 0.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bii_231_160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.4144 47.8433L79.2888 31.75L91.5339 37.9593L97.998 41.1554L99.998 44.6195L98.2839 49.6506L93.5388 56.4317L78.2493 62.9497L72.4144 47.8433Z",
    fill: "white",
    fillOpacity: 0.2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bii_231_160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0837 44.8384L24.2093 60.9316L11.9641 54.7223L5.5 51.5262L3.5 48.0621L5.2141 43.031L9.9593 36.2499L25.2487 29.732L31.0837 44.8384Z",
    fill: "white",
    fillOpacity: 0.2
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_bii_231_160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.3336 29.3384L23.9593 31.4316L23.2141 17.7223L22.75 10.5262L24.75 7.06209L29.9641 6.031L38.2093 6.74991L51.4987 16.732L41.3336 29.3384Z",
    fill: "white",
    fillOpacity: 0.2
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_bii_231_160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 65.5L50.5 79.5L39 87L33 91L29 91L25.5 87L22 79.5L24 63L40 65.5Z",
    fill: "white",
    fillOpacity: 0.2
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_bii_231_160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.1644 65.3433L78.5388 63.25L79.2839 76.9593L79.748 84.1554L77.748 87.6195L72.5339 88.6506L64.2888 87.9317L50.9993 77.9497L61.1644 65.3433Z",
    fill: "white",
    fillOpacity: 0.2
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_bii_231_160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5 48L26 32.5L41 30L52 16.5L62.5 29L78.5 32L73 48L77.5 62.5L62 65.5L52 78.5L42 65.5L25.5 63L31.5 48Z",
    fill: "white",
    fillOpacity: 0.2
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_231_160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.0008 37.9883C53.7674 37.9883 55.4943 38.5123 56.9631 39.4939C58.4319 40.4756 59.5766 41.8709 60.2522 43.5032C60.9279 45.1355 61.1042 46.9316 60.7589 48.6642C60.4137 50.3967 59.5623 51.988 58.3124 53.2366C57.0626 54.4852 55.4706 55.335 53.7377 55.6786C52.0048 56.0222 50.2089 55.8441 48.5772 55.1669C46.9455 54.4896 45.5514 53.3436 44.5711 51.8739C43.5909 50.4041 43.0686 48.6767 43.0703 46.91C43.0738 44.5438 44.0162 42.2756 45.6906 40.6037C47.365 38.9317 49.6345 37.9926 52.0008 37.9926",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2174 31.3534C83.1536 30.9881 82.0812 30.649 81 30.336C81.1797 29.6055 81.3464 28.8722 81.5 28.136C83.9348 16.3099 82.3435 6.77944 76.9 3.64031C71.6826 0.631615 63.1522 3.77075 54.5348 11.2707C53.6855 12.0099 52.8565 12.7707 52.0478 13.5534C51.5058 13.0316 50.9551 12.5215 50.3956 12.0229C41.3609 4.00988 32.3043 0.635963 26.8696 3.77509C21.6652 6.79248 20.1217 15.7534 22.3043 26.962C22.5275 28.0722 22.7739 29.1765 23.0435 30.2751C21.7696 30.6403 20.5304 31.0273 19.3478 31.4403C8.76087 35.136 2 40.9186 2 46.9186C2 53.1142 9.26087 59.3316 20.287 63.0925C21.1797 63.3997 22.0812 63.6838 22.9913 63.9447C22.6957 65.1244 22.4348 66.3128 22.2087 67.5099C20.113 78.5229 21.7478 87.2707 26.9478 90.2707C32.313 93.3664 41.3217 90.1838 50.1 82.5142C50.7957 81.9113 51.4913 81.2707 52.187 80.5925C53.0623 81.4418 53.9609 82.2649 54.8826 83.062C63.387 90.3751 71.7783 93.3229 76.9696 90.3229C82.3391 87.2142 84.0826 77.8186 81.8174 66.3881C81.6435 65.5186 81.4435 64.6287 81.2174 63.7186C81.8493 63.5331 82.4696 63.3403 83.0783 63.1403C94.5435 59.3403 102 53.1968 102 46.9186C102 40.8925 95.0217 35.0707 84.2174 31.3534ZM57.3478 14.4968C64.7304 8.07075 71.6304 5.54031 74.7826 7.34901C78.1304 9.27944 79.4261 17.0664 77.3217 27.2794C77.1855 27.9461 77.0362 28.6084 76.8739 29.2664C72.4675 28.2676 67.9997 27.5617 63.5 27.1534C60.9216 23.4498 58.0964 19.9244 55.0435 16.6012C55.7913 15.8823 56.5565 15.1809 57.3391 14.4968H57.3478ZM31.5217 52.036C32.429 53.7867 33.3754 55.5113 34.3609 57.2099C35.3667 58.949 36.413 60.6635 37.5 62.3533C34.4043 62.0187 31.3277 61.5253 28.2826 60.8751C29.1696 58.0186 30.2565 55.049 31.5261 52.0403L31.5217 52.036ZM31.5217 41.9925C30.2783 39.0447 29.2174 36.1447 28.3478 33.3403C31.1957 32.7012 34.2391 32.1794 37.4087 31.7838C36.3478 33.436 35.3261 35.1171 34.3435 36.8273C33.358 38.5258 32.4159 40.2476 31.5174 41.9925H31.5217ZM33.7913 47.0186C35.1072 44.2794 36.5275 41.5925 38.0522 38.9577C39.5652 36.32 41.1797 33.7476 42.8957 31.2403C45.8696 31.0142 48.9174 30.8925 52 30.8925C55.0956 30.8925 58.1478 31.0142 61.1217 31.2403C62.8174 33.7476 64.4232 36.3128 65.9391 38.936C67.4638 41.562 68.9015 44.236 70.2522 46.9577C68.9188 49.7055 67.487 52.4041 65.9565 55.0533C64.4406 57.6852 62.8406 60.2649 61.1565 62.7925C58.1913 63.0099 55.1261 63.1142 52 63.1142C48.887 63.1142 45.8609 63.0186 42.9478 62.8273C41.2203 60.3055 39.5913 57.7215 38.0609 55.0751C36.5362 52.4374 35.113 49.7505 33.7913 47.0142V47.0186ZM69.6609 57.1925C70.6638 55.4447 71.629 53.6765 72.5565 51.8881C73.827 54.7614 74.9473 57.6987 75.913 60.6881C72.8341 61.3791 69.7211 61.9088 66.587 62.2751C67.642 60.5997 68.6652 58.9041 69.6565 57.1881L69.6609 57.1925ZM72.513 41.9968C71.5913 40.2461 70.6348 38.5128 69.6435 36.7968C68.6638 35.1099 67.6493 33.4432 66.6 31.7968C69.787 32.2012 72.8435 32.736 75.7174 33.3925C74.7947 36.3141 73.7252 39.1873 72.513 42.0012V41.9968ZM52.0435 19.6664C54.1242 21.9339 56.089 24.305 57.9304 26.7707C53.9942 26.5823 50.0551 26.5823 46.113 26.7707C48.0565 24.2055 50.0478 21.8229 52.0478 19.6664H52.0435ZM29.0174 7.47075C32.3652 5.53596 39.7565 8.29683 47.5565 15.2229C48.0565 15.6664 48.5565 16.1273 49.0565 16.6055C45.9859 19.9293 43.1391 23.4529 40.5348 27.1534C36.0483 27.5561 31.5926 28.2489 27.1957 29.2273C26.9406 28.207 26.7116 27.178 26.5087 26.1403V26.149C24.6261 16.5403 25.8739 9.29683 29.0174 7.47944V7.47075ZM24.1304 59.8316C23.3043 59.5939 22.4841 59.3374 21.6696 59.062C17.4322 57.729 13.4764 55.6274 10 52.862C9.00517 52.1782 8.16122 51.2975 7.52032 50.2744C6.87942 49.2514 6.45521 48.1077 6.27391 46.9142C6.27391 43.2751 11.7 38.6316 20.7522 35.4794C21.8913 35.0794 23.0391 34.7171 24.1957 34.3925C25.5388 38.7039 27.1656 42.9218 29.0652 47.0186C27.1415 51.1749 25.4945 55.4538 24.1348 59.8273L24.1304 59.8316ZM47.287 79.3099C44.016 82.3101 40.2209 84.683 36.0913 86.3099C35.0035 86.8314 33.8203 87.1244 32.6149 87.1707C31.4094 87.2171 30.2073 87.0159 29.0826 86.5794C25.9304 84.7533 24.6174 77.736 26.4043 68.3186C26.6188 67.2026 26.8623 66.0954 27.1348 64.9968C31.5783 65.9502 36.0814 66.601 40.613 66.9447C43.2385 70.665 46.1055 74.2089 49.1956 77.5534C48.5754 78.1534 47.9406 78.7374 47.2913 79.3055L47.287 79.3099ZM52.1652 74.4751C50.1391 72.2925 48.1217 69.8751 46.1478 67.2751C48.0609 67.3505 50.0116 67.3881 52 67.3881C54.0377 67.3881 56.0493 67.3447 58.0348 67.2577C56.2028 69.7622 54.2437 72.1711 52.1652 74.4751ZM78.1087 80.4186C78.0166 81.6223 77.6786 82.7944 77.1155 83.8624C76.5523 84.9303 75.7761 85.8713 74.8348 86.6273C71.6826 88.4534 64.9435 86.0794 57.6739 79.8273C56.842 79.1142 56.0043 78.3519 55.1609 77.5403C58.1916 74.1853 60.9921 70.6294 63.5435 66.8968C68.1005 66.5125 72.6257 65.8153 77.087 64.8099C77.2899 65.6331 77.4696 66.4389 77.6261 67.2273C78.5937 71.5592 78.7559 76.0323 78.1043 80.4229L78.1087 80.4186ZM81.7348 59.0838C81.1826 59.2664 80.6217 59.4403 80.0478 59.6055C78.6503 55.2738 76.9594 51.0423 74.987 46.9403C76.8866 42.8941 78.5134 38.7254 79.8565 34.462C80.8739 34.7534 81.8696 35.0707 82.8261 35.3968C92.087 38.5794 97.7304 43.2925 97.7304 46.9186C97.7304 50.7881 91.6304 55.8055 81.7304 59.0838H81.7348Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_231_160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.2174 31.3534C83.1536 30.9881 82.0812 30.649 81 30.336C81.1797 29.6055 81.3464 28.8722 81.5 28.136C83.9348 16.3099 82.3435 6.77944 76.9 3.64031C71.6826 0.631615 63.1522 3.77075 54.5348 11.2707C53.6855 12.0099 52.8565 12.7707 52.0478 13.5534C51.5058 13.0316 50.9551 12.5215 50.3956 12.0229C41.3609 4.00988 32.3043 0.635963 26.8696 3.77509C21.6652 6.79248 20.1217 15.7534 22.3043 26.9621C22.5275 28.0722 22.7739 29.1765 23.0435 30.2751C21.7696 30.6403 20.5304 31.0273 19.3478 31.4403C8.76087 35.136 2 40.9186 2 46.9186C2 53.1142 9.26087 59.3316 20.287 63.0925C21.1797 63.3997 22.0812 63.6838 22.9913 63.9447C22.6957 65.1244 22.4348 66.3128 22.2087 67.5099C20.113 78.5229 21.7478 87.2707 26.9478 90.2707C32.313 93.3664 41.3217 90.1838 50.1 82.5142C50.7957 81.9113 51.4913 81.2707 52.187 80.5925C53.0623 81.4418 53.9609 82.2649 54.8826 83.062C63.387 90.3751 71.7783 93.3229 76.9696 90.3229C82.3391 87.2142 84.0826 77.8186 81.8174 66.3881C81.6435 65.5186 81.4435 64.6287 81.2174 63.7186C81.8493 63.5331 82.4696 63.3403 83.0783 63.1403C94.5435 59.3403 102 53.1968 102 46.9186C102 40.8925 95.0217 35.0707 84.2174 31.3534V31.3534ZM57.3478 14.4968C64.7304 8.07075 71.6304 5.54031 74.7826 7.34901C78.1304 9.27944 79.4261 17.0664 77.3217 27.2794C77.1855 27.9461 77.0362 28.6084 76.8739 29.2664C72.4675 28.2676 67.9997 27.5617 63.5 27.1534C60.9216 23.4498 58.0964 19.9244 55.0435 16.6012C55.7913 15.8823 56.5565 15.1809 57.3391 14.4968H57.3478ZM31.5217 52.036C32.429 53.7867 33.3754 55.5113 34.3609 57.2099C35.3667 58.949 36.413 60.6635 37.5 62.3533C34.4043 62.0187 31.3277 61.5253 28.2826 60.8751C29.1696 58.0186 30.2565 55.049 31.5261 52.0403L31.5217 52.036ZM31.5217 41.9925C30.2783 39.0447 29.2174 36.1447 28.3478 33.3403C31.1957 32.7012 34.2391 32.1794 37.4087 31.7838C36.3478 33.436 35.3261 35.1171 34.3435 36.8273C33.358 38.5258 32.4159 40.2476 31.5174 41.9925H31.5217ZM33.7913 47.0186C35.1072 44.2794 36.5275 41.5925 38.0522 38.9577C39.5652 36.32 41.1797 33.7476 42.8957 31.2403C45.8696 31.0142 48.9174 30.8925 52 30.8925C55.0957 30.8925 58.1478 31.0142 61.1217 31.2403C62.8174 33.7476 64.4232 36.3128 65.9391 38.936C67.4638 41.562 68.9014 44.236 70.2522 46.9577C68.9188 49.7055 67.487 52.4041 65.9565 55.0533C64.4406 57.6852 62.8406 60.2649 61.1565 62.7925C58.1913 63.0099 55.1261 63.1142 52 63.1142C48.887 63.1142 45.8609 63.0186 42.9478 62.8273C41.2203 60.3055 39.5913 57.7215 38.0609 55.0751C36.5362 52.4374 35.113 49.7505 33.7913 47.0142V47.0186ZM69.6609 57.1925C70.6638 55.4447 71.629 53.6765 72.5565 51.8881C73.827 54.7614 74.9473 57.6987 75.913 60.6881C72.8341 61.3791 69.7211 61.9088 66.587 62.2751C67.642 60.5997 68.6652 58.9041 69.6565 57.1881L69.6609 57.1925ZM72.513 41.9968C71.5913 40.2461 70.6348 38.5128 69.6435 36.7968C68.6638 35.1099 67.6493 33.4432 66.6 31.7968C69.787 32.2012 72.8435 32.736 75.7174 33.3925C74.7947 36.3141 73.7252 39.1873 72.513 42.0012V41.9968ZM52.0435 19.6664C54.1242 21.9339 56.089 24.305 57.9304 26.7707C53.9942 26.5823 50.0551 26.5823 46.113 26.7707C48.0565 24.2055 50.0478 21.8229 52.0478 19.6664H52.0435ZM29.0174 7.47074C32.3652 5.53596 39.7565 8.29683 47.5565 15.2229C48.0565 15.6664 48.5565 16.1273 49.0565 16.6055C45.9859 19.9293 43.1391 23.4529 40.5348 27.1534C36.0483 27.5561 31.5926 28.2489 27.1957 29.2273C26.9406 28.207 26.7116 27.178 26.5087 26.1403V26.149C24.6261 16.5403 25.8739 9.29683 29.0174 7.47944V7.47074ZM24.1304 59.8316C23.3043 59.5939 22.4841 59.3374 21.6696 59.062C17.4322 57.7291 13.4764 55.6274 10 52.862C9.00517 52.1782 8.16122 51.2975 7.52032 50.2744C6.87942 49.2514 6.45521 48.1077 6.27391 46.9142C6.27391 43.2751 11.7 38.6316 20.7522 35.4794C21.8913 35.0794 23.0391 34.7171 24.1957 34.3925C25.5388 38.7039 27.1656 42.9218 29.0652 47.0186C27.1415 51.1749 25.4945 55.4538 24.1348 59.8273L24.1304 59.8316ZM47.287 79.3099C44.016 82.3101 40.2209 84.683 36.0913 86.3099C35.0035 86.8314 33.8203 87.1244 32.6149 87.1707C31.4094 87.2171 30.2073 87.0159 29.0826 86.5794C25.9304 84.7533 24.6174 77.736 26.4043 68.3186C26.6188 67.2026 26.8623 66.0954 27.1348 64.9968C31.5783 65.9502 36.0814 66.601 40.613 66.9447C43.2385 70.665 46.1055 74.2089 49.1956 77.5534C48.5754 78.1534 47.9406 78.7374 47.2913 79.3055L47.287 79.3099ZM52.1652 74.4751C50.1391 72.2925 48.1217 69.8751 46.1478 67.2751C48.0609 67.3505 50.0116 67.3881 52 67.3881C54.0377 67.3881 56.0493 67.3447 58.0348 67.2577C56.2028 69.7622 54.2437 72.1711 52.1652 74.4751V74.4751ZM78.1087 80.4186C78.0166 81.6223 77.6786 82.7944 77.1155 83.8624C76.5523 84.9303 75.7761 85.8713 74.8348 86.6273C71.6826 88.4534 64.9435 86.0794 57.6739 79.8273C56.842 79.1142 56.0043 78.3519 55.1609 77.5403C58.1916 74.1853 60.9921 70.6294 63.5435 66.8968C68.1005 66.5125 72.6257 65.8153 77.087 64.8099C77.2899 65.6331 77.4696 66.4389 77.6261 67.2273C78.5937 71.5592 78.7559 76.0323 78.1043 80.4229L78.1087 80.4186ZM81.7348 59.0838C81.1826 59.2664 80.6217 59.4403 80.0478 59.6055C78.6503 55.2738 76.9594 51.0423 74.987 46.9403C76.8866 42.8941 78.5134 38.7254 79.8565 34.462C80.8739 34.7534 81.8696 35.0707 82.8261 35.3968C92.087 38.5794 97.7304 43.2925 97.7304 46.9186C97.7304 50.7881 91.6304 55.8055 81.7304 59.0838H81.7348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0008 37.9883C53.7674 37.9883 55.4943 38.5123 56.9631 39.4939C58.4319 40.4756 59.5766 41.8709 60.2522 43.5032C60.9279 45.1355 61.1042 46.9316 60.7589 48.6642C60.4137 50.3967 59.5623 51.988 58.3124 53.2366C57.0626 54.4852 55.4706 55.335 53.7377 55.6786C52.0047 56.0222 50.2089 55.8441 48.5772 55.1669C46.9455 54.4896 45.5514 53.3436 44.5711 51.8739C43.5909 50.4041 43.0686 48.6767 43.0703 46.91C43.0738 44.5438 44.0162 42.2756 45.6906 40.6037C47.365 38.9317 49.6345 37.9926 52.0008 37.9926",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bii_231_160",
    x: 48,
    y: 0,
    width: 36.5,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_231_160"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_231_160",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_231_160"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_231_160",
    result: "effect3_innerShadow_231_160"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bii_231_160",
    x: 68.4141,
    y: 27.75,
    width: 35.584,
    height: 39.1997,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_231_160"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_231_160",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_231_160"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_231_160",
    result: "effect3_innerShadow_231_160"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bii_231_160",
    x: -0.5,
    y: 25.7319,
    width: 35.584,
    height: 39.1997,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_231_160"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_231_160",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_231_160"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_231_160",
    result: "effect3_innerShadow_231_160"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_bii_231_160",
    x: 18.75,
    y: 2.03076,
    width: 36.748,
    height: 33.4009,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_231_160"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_231_160",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_231_160"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_231_160",
    result: "effect3_innerShadow_231_160"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_bii_231_160",
    x: 18,
    y: 59,
    width: 36.5,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_231_160"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_231_160",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_231_160"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_231_160",
    result: "effect3_innerShadow_231_160"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_bii_231_160",
    x: 47,
    y: 59.25,
    width: 36.748,
    height: 33.4004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_231_160"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_231_160",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_231_160"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_231_160",
    result: "effect3_innerShadow_231_160"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_bii_231_160",
    x: 21.5,
    y: 12.5,
    width: 61,
    height: 70,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_231_160"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_231_160",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_231_160"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_231_160",
    result: "effect3_innerShadow_231_160"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_231_160",
    x: 0,
    y: 0.508301,
    width: 104,
    height: 92.9761,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_231_160"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_231_160"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 88.9716,
    fill: "white",
    transform: "translate(2 2.51416)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReact);
export default __webpack_public_path__ + "static/media/React.e7de1829a6409ab266a0424985257a31.svg";
export { ForwardRef as ReactComponent };